export default __webpack_public_path__ + "static/media/Performance-Marketing-Header.ada6a782.png";